import React from "react";
import { motion } from "framer-motion";

const LetterAnimation = ({ text, delay, className = "" }) => {
  const letterVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    animate: {
      opacity: 1,
      y: 0,
    },
  };

  // Vérifier si 'text' est une chaîne de caractères, si oui, on le transforme en tableau avec un seul élément
  const words = typeof text === "string" ? [{ word: text, style: {} }] : text;

  return (
    <div className={`mx-auto ${className}`}>
      {words.map((word, wordIndex) => {
        // Si le mot est une chaîne simple, on l'entoure d'un objet avec des styles par défaut
        const wordObject = typeof word === "string" ? { word, style: {} } : word;

        return (
          <span key={wordIndex} style={wordObject.style}>
            {wordObject.word.split("").map((letter, letterIndex) => (
              <motion.span
                key={letterIndex}
                variants={letterVariants}
                initial="initial"
                animate="animate"
                transition={{ delay: (wordIndex * wordObject.word.length + letterIndex) * delay }}
              >
                {letter}
              </motion.span>
            ))}
            {/* Ajouter un espace après chaque mot sauf le dernier */}
            {wordIndex < words.length - 1 && " "}
          </span>
        );
      })}
    </div>
  );
};

export default LetterAnimation;

